<template>
  <tr>
    <td
      :class="{ red: identifierCounts.login[account.login] > 1 }"
    >
      <v-text-field
        v-model="account.login"
        hide-details
      />
    </td>
    <td
      :class="{ red: identifierCounts.email[account.email] > 1 }"
    >
      <v-text-field
        v-model="account.email"
        hide-details
      />
    </td>
    <td>
      <v-text-field
        v-model="account.password"
        hide-details
      />
    </td>
    <td>
      <v-text-field
        v-model="account.currency"
        hide-details
      />
    </td>
    <td>
      <v-text-field
        v-model="account.country"
        hide-details
      />
    </td>
    <td
      :class="{ red: identifierCounts.phone[account.phone] > 1 }"
    >
      <v-text-field
        v-model="account.phone"
        hide-details
      />
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    account: {
      type: Object,
      required: true,
    },
    identifierCounts: {
      type: Object,
      default: () => ({
        email: {},
        phone: {},
      })
    },
    error: String,
  }
}
</script>
